import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const AboutPreview = () => (
  <section data-testid="about-preview-section" className="border-t border-stone/60">
    <div className="mx-auto max-w-3xl px-6 md:px-10 py-28 md:py-40 text-center">
      <Reveal>
        <p className="eyebrow mb-6">The Author</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight" data-testid="about-preview-headline">
          About Tara Aurora
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-9 text-base md:text-lg leading-relaxed text-taupe">
          Tara Aurora writes from the intersection of lived experience,
          nervous-system education, somatic awareness and a lifelong curiosity
          about why we become who we become.
        </p>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-taupe">
          Her work explores what can happen when insight alone isn’t enough —
          and we begin listening to the body as part of the conversation.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <Link
          to="/about"
          data-testid="about-preview-button"
          className="mt-10 inline-block border border-stone text-charcoal text-xs uppercase tracking-[0.25em] px-10 py-4 hover:border-teal hover:text-deepteal transition-colors duration-500"
        >
          About Tara
        </Link>
      </Reveal>
    </div>
  </section>
);

export default AboutPreview;
